import { Selector } from "@ngxs/store";
import { PermissionState, PermissionStateModel } from "./permision.state";
import { Permission } from "../models/permission.model";
import { Menu } from "src/app/shared/models/menu.model";
import { PermissionTable } from "../models/permission-table.model";

export class PermissionSelectors {

    @Selector([PermissionState])
    static getPermissions(state: PermissionStateModel): Permission[] {
      return state.permissions;
    }

    @Selector([PermissionState])
    static getMenu(state: PermissionStateModel): Menu[] {
      return state.menu;
    }

    @Selector([PermissionState])
    static getPermissionsTable(state: PermissionStateModel): PermissionTable[] {
      return state.permissionsTable;
    }
  
    @Selector([PermissionState])
    static getIsLoadingPermissions(state: PermissionStateModel) : boolean {
      return state.isLoading;
    }
  }